import { FilterModel } from 'core/models';
import { FocusEventHandler } from 'react-select';

export interface IProps {
  config: FilterModel.IConfig;
  value: any;
  isDisabled?:boolean;
  onChange: (
    key: string,
    value: any,
    label?: string,
  ) => void;
  removeBorderClass?: string;
  addBorderClass?: string;
  pendoClassName?: string;
  enableV1Reports?:boolean;
  isReportBuilder?: boolean;
  isGroupedOptions?: boolean;
  onFocus?: FocusEventHandler;
  menuWidth?: string;
}

export enum MenuPosition {
  fixed = 'fixed',
  absolute = 'absolute'
}

export enum MenuPlacement {
  auto = 'auto'
}
